import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";
import { last } from 'rxjs';

const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-measurements',
  templateUrl: './measurements.component.html',
  styleUrls: ['./measurements.component.css']
})
export class MeasurementsComponent extends BaseComponent implements OnInit {
  database = inject(Database)
  isAuthenticatedWithFirebase = false
  measurementsRef: any
  measurements: any
  measurementsArray: any
  scenarios: any
  scenario: any = {}
  scenarioName = ''
  showAddScenario = false
  showAddRecord = false
  newScenarioaname = ''
  newPlayerName = ''
  players: any = []
  player:any = {}
  recordings: any = []
  record: any = {}

  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }
  async ngOnInit(): Promise<void> {

    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  async signOut() {
    try {
      await getAuth().signOut()
      this.isAuthenticatedWithFirebase = false
    } catch (error) {
      console.log(error)
    }
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  private async onSuccessfullLogin() {
    await this.getData()
  }
  async getData() {
    this.loader.show()
    this.measurementsRef = ref(this.database, 'measurements');
    const snapshot = await get(this.measurementsRef);
    if (snapshot.exists()) {
      // const val = snapshot.val();
      this.measurements = snapshot.val();

      this.scenarios = this.getKeys(this.measurements)
      this.measurementsArray = this.collectionToArray2(this.measurements)
      // this.worldskeys = this.getKeys(this.worlds)
    }

    this.loader.hide()
  }
  addScenarioModal() {
    this.showAddScenario = true
  }
  async addScenario() {
    if (this.newScenarioaname == '') {
      alert('Please enter the scenario name')
      return
    }
    const newScenario = {
      lastDate: new Date().toISOString(),
      startDate: new Date().toISOString()
    }

    this.measurements[this.newScenarioaname] = newScenario
    this.showAddScenario = false
    this.newScenarioaname = ''
    await this.updateMeasurements()
    await this.getData()
  }
  async updateMeasurements() {
    await set(this.measurementsRef, this.measurements);
  }

  async deleteScenario(name: string) {
    delete this.measurements[name]
    await this.updateMeasurements()
    await this.getData()
  }

  selectScenario(name: string) {
    this.scenarioName = name
    this.scenario = this.measurements[name]
    this.player = {}
    this.players = []
    let index = 0
    for (let key in this.scenario) {
      if (key == 'lastDate' || key == 'startDate') continue
      let record = {id:index,name:key, value:this.scenario[key]}
      this.players.push(record)
    }
  }
  
  async addPlayer() {
    if (this.newPlayerName == '') {
      alert('Please enter the player name')
      return
    }
    let newPLayer = {
      name: this.newPlayerName, lastDate: new Date().toISOString(), recordings: []
    }
    this.scenario[this.newPlayerName] = newPLayer
    await this.updateMeasurements()
    this.selectScenario(this.scenarioName)
  }
  selectPlayer(c: any) {
    this.player = c
    if (this.player.value.recordings == null) this.player.value.recordings = []
    this.recordings = c.value.recordings
  }
  deletePlayer(playername: string){
    delete this.scenario[playername]
    this.selectScenario(this.scenarioName)
  }
  deleteRecord(i: number){
    this.recordings.splice(i, 1)
    this.updateMeasurements()
  }
  addRecordModal() {
    this.showAddRecord = true
  }
  addRecord(){
    this.recordings.push(this.record)
    this.scenario.lastDate = new Date().toISOString()
    this.updateMeasurements()
  }
  async updateRecordings(){
    this.scenario[this.player.name].recordings = this.recordings
    await this.updateMeasurements()
  }
}
